<script>
export default {
  name: 'DelayComponent',
  props: {
    delay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
      timer: null
    };
  },
  mounted() {
    this.timer = setTimeout(() => this.show = true, this.delay);
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  render() {
    return this.show ? this.$slots.default : null;
  }
};
</script>
